export default "__VITE_PUBLIC_ASSET__207caa8e__"